import i18n, { i18n_t } from '@/locales/i18n';
import { AccessTokenManager } from '@/renderer/scripts/libs/smh-sdk-class';
import smh, { SMH } from '@/renderer/scripts/smh';
import { httpUrl } from '@/renderer/scripts/http';
import storage from '@/renderer/scripts/utils/storage/index';
import store from '@/renderer/store';
import meeting from '@/renderer/scripts/utils/meeting';
import { showLog } from '@/renderer/scripts/utils/tools/index';
import { IS_BROWSER } from '@/common/constant/platform';
const spaceATM = new AccessTokenManager({
  httpParams: {
    baseURL: httpUrl.SMHUrl,
    userToken: '',
    organizationId: 0,
    envType: IS_BROWSER ? 'web' : 'node',
  },
  storage: {
    get: () =>
      new Promise((resolve, reject) => {
        const tokenMap = storage.get<Record<string, SMH.SpaceToken>>(storage.StoreKey.COLLECT_ACCESS_TOKEN_MAP);
        resolve(tokenMap);
      }),
    set: (spaceMap: Record<string, SMH.SpaceToken>) => {
      storage.set(storage.StoreKey.ACCESS_TOKEN_MAP, spaceMap);
    },
    del: () => {
      storage.del(storage.StoreKey.ACCESS_TOKEN_MAP);
    },
  },
});

// 日志落盘
spaceATM.on('request', ({ config }) => {
  if (meeting.isTMWebview) {
    // 腾讯会议内所有接口增加参数
    config.params.pf = 'meeting';
  }
  config.starttime = Date.now();
  const logParams = showLog('SpaceATM request', null, null, config);
  logParams && logger.smh(...logParams);
});
spaceATM.on('response', res => {
  const { config, data, error } = res;
  if (config) config.endtime = Date.now();
  const logParams = showLog('SpaceATM response', error, data, config);
  logParams && logger.smh(...logParams);
});
httpUrl
  .on(httpUrl.EVENT_MAP.SMHHostInit, () => {
    spaceATM.initHttpParams({
      baseURL: httpUrl.SMHUrl,
    });
  })
  .on(httpUrl.EVENT_MAP.SMHHostChanged, () => {
    spaceATM.initHttpParams({
      baseURL: httpUrl.SMHUrl,
    });
  });
smh.initGetInfoFunction({
  getSpaceInfo: async (spaceId = '', isFetch = false, spaceOrgId?: number) => {
    let spaceOrgIdNumber = spaceOrgId;
    // 若有值，则需要规范传值
    if (spaceOrgId) {
      spaceOrgIdNumber = Number(spaceOrgId);
      // 若不符合规范,直接报错;否则后续逻辑还是会出错
      if (Number.isNaN(spaceOrgIdNumber)) {
        /* i18n-ignore*/
        throw new Error(`请注意，请传递正确的数字类型,当前的spaceOrgId值为：  ${spaceOrgIdNumber} `);
      }
    }
    if (store.getters.isLogined) {
      if (isFetch) {
        return spaceATM.fetch(spaceId, 0, spaceOrgIdNumber);
      }
      return spaceATM.get(spaceId, spaceOrgIdNumber);
    }
    // FIX: 修复未登录时(在分享外链)由于fetch里的sleep导致请求延迟
    return {
      updateTime: 0,
      spaceId: '',
      accessToken: '',
      expiresIn: 0,
      libraryId: '',
    };
  },
});
export default spaceATM;
